import React from "react"
import { compose, branch, renderComponent } from "recompose"
import cn from "classnames"

import env from "../../env"

import styles from "./styles.css"

const { REACT_APP_4SIDES_ORIGIN } = env

const EmptyTitle = () => `нет данных`

const Link = ({ title = ``, to, className }) => (
  <a
    href={`${REACT_APP_4SIDES_ORIGIN}${to}`}
    className={cn([styles.link, className])}
  >
    <div>
      <span>{title}</span>
    </div>
  </a>
)

const enhance = compose(
  branch(({ title }) => !title, renderComponent(EmptyTitle)),
)

export default enhance(Link)
